import { SEARCH_LOT } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SEARCH_LOT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEARCH_LOT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SEARCH_LOT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
